"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryCompactWorkItemHeader = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const HistoryCompactWorkItemHeader = () => (react_1.default.createElement("div", { className: 'history-compact-work-header' },
    react_1.default.createElement("div", null, "Song Title"),
    react_1.default.createElement("div", null, "Writers"),
    react_1.default.createElement("div", null,
        react_1.default.createElement("span", { className: 'label-with-tooltip' },
            react_1.default.createElement(CustomToolTip_1.default, { info: react_1.default.createElement(react_1.default.Fragment, null, "This reflects total shares you have submitted to The MLC. These submitted shares are subject to review and approval by The MLC before being processed."), inverse: true, type: '?' }),
            "Your Total Submitted Shares"))));
exports.HistoryCompactWorkItemHeader = HistoryCompactWorkItemHeader;
